<template>
  <div
    v-if="message"
    class="c-alert o-grid o-grid--padding-normal o-grid--gutter-normal o-grid--direction-row o-wrap--padding-side-default o-grid--justify-content-center o-grid--align-items-center"
    :class="`c-alert--${type}`"
  >
    <div class="o-grid__group">
      <div class="o-grid__item o-grid__item--grow-0">
        <div
          class="c-alert__message"
          :class="{
            'o-feedback o-feedback--invalid o-feedback--icon': type === 'error'
          }"
        >
          {{ status }} {{ message }} {{ url }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "c-alert",
  computed: {
    ...mapState("alert", ["status", "message", "type", "url"])
  }
};
</script>
<style lang="scss">
.c-alert {
  width: 100%;
  z-index: z("alert");
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  &--success {
    background-color: $s-cp-sup-green;
  }
  &--error {
    background-color: $s-cp-neutral-white;
  }
}
</style>
